import * as React from 'react';
import { cn } from 'lib/utils';

type Props = React.ComponentProps<'div'>

const Column = ({ className, ...props }: Props) => {
  return (
    <div {...props} className={cn('flex flex-col shrink-0 gap-1 text-gray-600', className)} />
  );
};

type TitleProps = React.ComponentProps<'p'>

const InfoTitle = ({ className, ...props }: TitleProps) => {
  return (
    <p {...props} className={cn('font-GilroySemibold text-[14px]', className)} />
  );
};

type ContentProps = React.ComponentProps<'p'>

const InfoContent = ({ className, ...props }: ContentProps) => {
  return (
    <p {...props} className={cn('font-sans text-xs', className)} />
  );
};

export const InfoColumn = Object.assign(Column, {
  Title: InfoTitle,
  Content: InfoContent,
});